import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';
import { EGoogleLib } from '@shared/models/configurations.interface';

import { mapLibraryResolver } from '@shared/services/map-loader.resolver';
import { interactionsRoutes } from '@feature/customer/interactions/interctions.route';
import { requestRoutes } from '@feature/customer/requests/request.routes';

export const customerRoutes: Routes = [
  {
    path: 'customers',
    loadComponent: () =>
      import('@feature/customer/customer.component').then(
        m => m.CustomerComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'main-customers',
        pathMatch: 'full',
      },
      {
        path: 'main-customers',
        canActivate: [permissionGuard('DispatcherDistrictsView')],
        loadComponent: () =>
          import('@feature/customer/main-customer/main-customer.component').then(
            c => c.MainCustomerComponent
          ),
      },
      {
        path: 'main-customers/add',
        resolve: { lib: mapLibraryResolver(EGoogleLib.places) },
        canActivate: [permissionGuard('DispatcherDistrictsCreate')],
        loadComponent: () =>
          import('@feature/customer/main-customer/components/add-edit-main-customer/add-edit-main-customer.component').then(
            c => c.AddEditMainCustomerComponent
          ),
      },
      {
        path: 'main-customers/edit/:id',
        resolve: { lib: mapLibraryResolver(EGoogleLib.places) },
        canActivate: [permissionGuard('DispatcherDistrictsEdit')],
        loadComponent: () =>
          import('@feature/customer/main-customer/components/add-edit-main-customer/add-edit-main-customer.component').then(
            c => c.AddEditMainCustomerComponent
          ),
      },
      {
        path: 'customers-users',
        canActivate: [permissionGuard('DispatcherDistrictsUsersView')],
        loadComponent: () =>
          import('@feature/customer/customers-users/customers-users.component').then(
            c => c.CustomersUsersComponent
          ),
      },
      {
        path: 'sub-customers',
        resolve: { lib: mapLibraryResolver(EGoogleLib.places) },
        canActivate: [permissionGuard('DispatcherSchoolsView')],
        loadComponent: () =>
          import('@feature/customer/sub-customer/sub-customer.component').then(
            c => c.SubCustomerComponent
          ),
      },
      {
        path: 'sub-customer-mapping',
        canActivate: [permissionGuard('DispatcherSubCustomersMappingView')],
        loadComponent: () =>
          import('@feature/customer/sub-customer-mapping/sub-customer-mapping.component').then(
            c => c.SubCustomerMappingComponent
          ),
      },
      {
        path: 'incident-reports',
        canActivate: [permissionGuard('DispatcherIncidentReportView')],
        loadComponent: () =>
          import('./student-incident-reports/student-incident-reports.component').then(
            c => c.StudentIncidentReportsComponent
          ),
      },
      {
        path: 'usage-report',
        canActivate: [permissionGuard('DispatcherUsageReportView')],
        loadComponent: () =>
          import('./usage-report/usage-report.component').then(
            m => m.UsageReportComponent
          ),
      },
      ...interactionsRoutes,
      ...requestRoutes,
    ],
  },
];
